import React, { useState } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';

import GlobalSearch from '../common/GlobalSearch';
import { useAuth } from '../../context/AuthContext';
import './AppLayout.css';

function AppLayout() {
  const location = useLocation();
  const { isAdmin, status, logout, user } = useAuth();
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const isAuthenticatedRoute = status === 'authenticated';
  const isAuthScreen = location.pathname === '/login' || location.pathname === '/register';

  const handleLogout = async () => {
    setIsLoggingOut(true);

    try {
      await logout();
    } finally {
      setIsLoggingOut(false);
    }
  };

  const renderAuthActions = () => {
    if (isAuthScreen) {
      return null;
    }

    if (status === 'bootstrapping') {
      return <span className="app-header-session">Checking session...</span>;
    }

    if (status === 'anonymous') {
      return (
        <Link className="app-header-action app-header-action-primary" to="/login">
          Login
        </Link>
      );
    }

    return (
      <>
        <span className="app-header-user-pill" title={user?.email}>
          {user?.username || user?.email}
        </span>
        {isAdmin && (
          <Link className="app-header-action" to="/admin/invite">
            Admin Invite
          </Link>
        )}
        <button
          className="app-header-action app-header-action-button"
          disabled={isLoggingOut}
          onClick={handleLogout}
          type="button"
        >
          {isLoggingOut ? 'Logging Out...' : 'Logout'}
        </button>
      </>
    );
  };

  return (
    <div className="app-shell">
      <header className="app-header">
        <div className="app-header-inner">
          <Link className="app-brand" to="/">
            UFC
          </Link>
          <div className="app-header-tools">
            {isAuthenticatedRoute && !isAuthScreen && <GlobalSearch />}
            <div className="app-header-actions">
              {renderAuthActions()}
            </div>
          </div>
        </div>
      </header>

      <main className="app-main">
        <Outlet />
      </main>
    </div>
  );
}

export default AppLayout;
